export * from './average-dwell-time.model';
export * from './consolidated-entries-vehicular.model';
export * from './daily-report.model';
export * from './hourly-report.model';
